import React from 'react';
import { Box, Grid, GridItem, Text } from '@chakra-ui/react';
import { useColorModeValue } from '../../components/ui/color-mode';
import { lightMode, darkMode } from '../../theme/config';

const CustomerInfoSection = ({ customer }) => {
  const labelColor = useColorModeValue('gray.500', 'gray.400');
  const valueColor = useColorModeValue('gray.800', 'white');
  const backgroundColor = useColorModeValue(lightMode.boxBackgroundColor, darkMode.boxBackgroundColor);

  if (!customer) {
    return (
      <Box p={4}>
        <Text color="red.500">Error: No customer data available.</Text>
      </Box>
    );
  }

  const { firstName, lastName, email, phone, address } = customer;

  return (
    <Box
      border="1px solid"
      borderColor={backgroundColor}
      borderRadius="md"
      p={6}
      bg={backgroundColor}
    >
      <Text fontSize="lg" fontWeight="bold" mb={4}>
        Customer Information
      </Text>
      
      <Grid templateColumns={{ base: '1fr', md: '1fr 1fr' }} gap={6} mb={4}>
        <GridItem>
          <Text fontSize="sm" color={labelColor} mb={1}>
            Name
          </Text>
          <Text fontSize="md" fontWeight="semibold" color={valueColor}>
            {firstName && firstName + " " + lastName}
          </Text>
        </GridItem>

        <GridItem>
          <Text fontSize="sm" color={labelColor} mb={1}>
            Email
          </Text>
          <Text fontSize="md" fontWeight="semibold" color={valueColor}>
            {email}
          </Text>
        </GridItem>
      </Grid>

      <Box mb={4}>
        <Text fontSize="sm" color={labelColor} mb={1}>
          Phone
        </Text>
        <Text fontSize="md" fontWeight="semibold" color={valueColor}>
          {phone}
        </Text>
      </Box>

      <Box>
        <Text fontSize="sm" color={labelColor} mb={1}>
          Address
        </Text>
        <Text fontSize="md" fontWeight="semibold" color={valueColor}>
          {address}
        </Text>
      </Box>
    </Box>
  );
};

export default CustomerInfoSection;